/* IU release polish 4.0.1: accessible native actions; no cart or wishlist writes. */
(() => {
  'use strict';
  const counts = new WeakSet(), wishlistControls = new WeakSet(), reviewControls = new WeakSet();
  const cartLabel = value => /\+/.test(value) ? 'Peste 99 de articole' : `${Number(value) || 0} ${Number(value) === 1 ? 'articol' : 'articole'}`;
  function syncCount(count) {
    const bubble = count.closest('.cart-count-bubble');
    if (!bubble) return;
    const label = cartLabel(count.textContent.trim());
    bubble.querySelectorAll('.visually-hidden').forEach(node => { if (node.textContent !== label) node.textContent = label; });
    const trigger = bubble.closest('a,button');
    if (trigger) trigger.setAttribute('aria-label', `Coșul tău, ${label.toLowerCase()}`);
  }
  function syncWishlist(button) {
    const active = button.classList.contains('wishlist-added');
    button.setAttribute('aria-pressed', String(active));
    const label = active ? 'Elimină din favorite' : 'Adaugă la favorite';
    button.setAttribute('aria-label', label);
    button.title = label;
    const text = button.querySelector('.visually-hidden');
    if (text && text.textContent.trim() !== label) text.textContent = label;
  }
  const matches = (scope, selector) => [...(scope.matches?.(selector) ? [scope] : []), ...scope.querySelectorAll(selector)];
  function init(scope = document) {
    matches(scope, '.cart-count-bubble [data-cart-count]').forEach(count => {
      syncCount(count);
      if (counts.has(count)) return;
      counts.add(count);
      new MutationObserver(() => syncCount(count)).observe(count, {childList:true, subtree:true, characterData:true});
    });
    matches(scope, '.iu-wishlist-toggle[data-wishlist]').forEach(button => {
      syncWishlist(button);
      if (wishlistControls.has(button)) return;
      wishlistControls.add(button);
      new MutationObserver(() => syncWishlist(button)).observe(button, {attributes:true, attributeFilter:['class']});
    });
    matches(scope, '.jdgm-revs-tab .jdgm-revs-tab-btn').forEach(opener => {
      opener.setAttribute('aria-label', 'Deschide recenziile clienților');
    });
    matches(scope, '.jdgm-revs-tab .jdgm-close-ico').forEach(close => {
      close.setAttribute('aria-label', 'Închide recenziile');
      close.setAttribute('tabindex', '0');
      if (reviewControls.has(close)) return;
      reviewControls.add(close);
      close.addEventListener('keydown', event => {
        if (event.key !== 'Enter' && event.key !== ' ') return;
        event.preventDefault();
        close.click();
      });
    });
  }
  function ready() {
    init();
    new MutationObserver(records => {
      for (const record of records) for (const node of record.addedNodes) if (node.nodeType === 1) init(node);
    }).observe(document.body, {childList:true, subtree:true});
  }
  document.addEventListener('shopify:section:load', event => init(event.target));
  document.addEventListener('cart:updated', () => init());
  document.addEventListener('wishlist:refresh', () => init());
  window.addEventListener('pageshow', () => init());
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', ready, {once:true}); else ready();
})();
